export default "__VITE_ASSET__Cb0ryOAs__"